import { useState } from 'react';

/* CSS */
import styles from './PasswordInput.module.css';

/* Icons */
import eye_open from '../../assets/icons/eye_open.svg';
import eye_close from '../../assets/icons/eye_close.svg';

const PasswordInput = ({ label, value, onChange, containerStyle, labelStyle }) => {

    // The component manages its own toggle state!
    const [show, setShow] = useState(false);

    return (
        <div className={styles.container} style={containerStyle}>
            {/* The label */}
            {label && <div className={styles.label} style={labelStyle}>{label}</div>}

            <div className={styles.inputWrapper}>
                {/* The input */}
                <input
                    type={show ? "text" : "password"}
                    autoComplete="current-password"
                    name="password"
                    className={styles.input}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder="••••••••"
                />
                {/* The eye icon */}
                <button
                    type="button"
                    className={styles.toggleButton}
                    onClick={() => setShow(!show)}
                    tabIndex="-1" // Stops users from tabbing onto the eye icon
                >
                    <img src={show ? eye_open : eye_close} className={styles.eyeIcon} alt="Toggle Visibility" />
                </button>
            </div>
        </div>
    );
};

export default PasswordInput;
